export enum UserProvider {
  Local,
  Group,
  Site,
  Task,
  Contact,
  PossibleContact,
}
